export function getPlacementChatContextFromChannel(channelUrl: string) {
  const [workplaceId, workerId, placementId] = channelUrl.split("_") as Array<string | undefined>;
  return {
    workplaceId,
    workerId,
    placementId,
  };
}
